import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

// External services used by the original component (kept for compatibility)
import { IMenuItem, NavigationService } from '../../../shared/services/navigation.service';
import { ILayoutConf, LayoutService } from '../../../shared/services/layout.service';
import { UsersService, UserCookieObj } from '../../../views/user/users.service';
import { CookieService } from 'ngx-cookie-service';
import { FullLoaderService } from '../../../shared/services/full-loader.service';
import { AwsSdkService } from '../../../shared/services/aws-sdk.service';
import { WebApiService } from '../../../shared/services/web-api.service';
import { SettingsService } from '../../../views/settings/settings.service';
import { HttpErrorResponse } from "@angular/common/http";

@Component({
  selector: 'app-sidebar-side',
  templateUrl: './sidebar-side.component.html',
  styleUrls: ['./sidebar-side.component.css']
})
export class SidebarSideComponent implements OnInit, AfterViewInit, OnDestroy {
  public menuItems!: IMenuItem[];
  public hasIconTypeMenuItem = false;
  public iconTypeMenuTitle = '';
  private menuItemsSub!: Subscription;
  private layoutConfSub!: Subscription;
  public layoutConf!: ILayoutConf;
  user: UserCookieObj;

  // Profile photo state
  showUploadPopup = false;
  showAdjustPopup = false;
  showSuccessPopup = false;
  uploadedImageSrc: string | null = null; // image chosen in flow
  currentPhotoSrc: string | null = null;  // persisted avatar
  currentPhotoS3Path: string | null = null;
  validationErrors: string[] = [];
  validationWarnings: string[] = [];
  private readonly allowedMime = new Set([
    'image/jpeg', 'image/jpg', 'image/png', 'image/webp'
  ]);
  private readonly maxBytes = 5 * 1024 * 1024; // 5 MB
  roleId:any;
  // Adjust controls
  zoom = 1;
  translateX = 0;
  translateY = 0;
  private dragging = false;
  private dragStartX = 0;
  private dragStartY = 0;
  private repositionCameraTimeout: any;

  private imgNatW = 0;
  private imgNatH = 0;
  private readonly viewportSize = 300;    // must match CSS: .pp-cropper-square
  private readonly visibleDiameterFallback = 220; // must match CSS: .pp-circle-ring
  private readonly zoomMin = 0.1;
  public readonly zoomMax = 4;
  private readonly zoomStep = 0.1;

  constructor(
    private navService: NavigationService,
    private layout: LayoutService,
    private usersService: UsersService,
    private cookieService: CookieService,
    private fullLoaderService: FullLoaderService,
    private router: Router,
    private awsSdkService: AwsSdkService,
    private webApiService: WebApiService,
    private settingsService: SettingsService,
  ) {
    try {
      this.user = JSON.parse(this.cookieService.get('user'));
      console.log("user",this.user);
    } catch {
      this.user = { name: 'User' } as any;
    }
  }

  get userInitials(): string {
    const n = (this.user?.name || '').trim();
    if (!n) return 'VM';
    return n.split(' ').filter(Boolean).map(p => p[0]).join('').slice(0, 2).toUpperCase();
  }

  get isCompact(): boolean {
    return this.layoutConf?.sidebarStyle === 'compact';
  }

  ngOnInit() {
    console.log(this.cookieService.getAll());
    this.user = JSON.parse(this.cookieService.get("user"));
    this.roleId = JSON.parse(this.cookieService.get('roleId'));

    try {
      const profilePath = this.cookieService.get('profilePath');
      if (profilePath && profilePath !== 'null' && profilePath !== 'undefined') {
        this.currentPhotoSrc = profilePath;
      }
    } catch {}

    this.iconTypeMenuTitle = this.navService.iconTypeMenuTitle;
    this.menuItemsSub = this.navService.menuItems$.subscribe((menuItem) => {
      this.menuItems = menuItem;
      //Checks item list has any icon type.
      this.hasIconTypeMenuItem = !!this.menuItems.filter(
        (item) => item.type === "icon"
      ).length;
    });
    this.layoutConf = this.layout.layoutConf;
    // React to layout changes (full ↔ compact ↔ closed) so the pill switch / hamburger
    // template bindings refresh immediately on toggle, not just on the next Zone tick.
    this.layoutConfSub = this.layout.layoutConf$.subscribe((conf) => {
      if (conf) this.layoutConf = conf;
    });
  }

  ngAfterViewInit(): void {
    this.positionFloatingCamera();
    window.addEventListener('resize', this.positionFloatingCamera);
  }

  ngOnDestroy() {
    if (this.menuItemsSub) {
      this.menuItemsSub.unsubscribe();
    }
    if (this.layoutConfSub) {
      this.layoutConfSub.unsubscribe();
    }
    window.removeEventListener('resize', this.positionFloatingCamera);

  }

  // Sidebar toggle: switches between full and compact (icon-only) mode
  toggleCollapse() {
    const isCurrentlyCompact = this.layoutConf.sidebarStyle === 'compact';
    console.log('[sidebar] toggleCollapse fired, currently:', this.layoutConf.sidebarStyle,
      '→ switching to', isCurrentlyCompact ? 'full' : 'compact');
    this.layout.publishLayoutChange({
      sidebarStyle: isCurrentlyCompact ? 'full' : 'compact',
      sidebarCompactToggle: !isCurrentlyCompact,
    });
    // Re-read layoutConf in case service didn't keep the same object reference.
    this.layoutConf = this.layout.layoutConf;
    // Reposition camera icon after transition completes (0.3s)
    setTimeout(() => this.positionFloatingCamera(), 350);
  }

  // Upload popup controls
  openUploadPopup(event?: Event) {
    event?.stopPropagation();
    this.showUploadPopup = true;
    this.showAdjustPopup = false;
    this.showSuccessPopup = false;
  }
  closeAllPopups() {
    this.showUploadPopup = false;
    this.showAdjustPopup = false;
    this.showSuccessPopup = false;
  }

  onFileSelected(event: any) {
    const file: File | undefined = event?.target?.files?.[0];
    if (!file) return;
    this.processIncomingFile(file);
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    const file = event.dataTransfer?.files?.[0];
    if (!file) return;
    this.processIncomingFile(file);
  }
  onDragOver(event: DragEvent) { event.preventDefault(); }

  removePhoto() {
    this.uploadedImageSrc = null;
    this.currentPhotoSrc = null;
  }

  goToAdjust() {
    if (!this.uploadedImageSrc) return;
    this.showUploadPopup = false;
    this.showAdjustPopup = true;
    this.prepareImageForAdjust(this.uploadedImageSrc);
  }
  backToUpload() { this.showAdjustPopup = false; this.showUploadPopup = true; }

  // Cropper interactions
  onZoomChange(e: any) {
    const val = e?.target?.value;
    const num = typeof val === 'string' ? parseFloat(val) : val;
    if (!isNaN(num)) {
      const prev = this.zoom;
      this.zoom = this.clampZoom(num);
      // zoom around center
      this.translateX = 0 - (0 - this.translateX) * (this.zoom / prev);
      this.translateY = 0 - (0 - this.translateY) * (this.zoom / prev);
      this.clampPan();
    }
  }
  startDrag(event: MouseEvent) {
    this.dragging = true;
    this.dragStartX = event.clientX - this.translateX;
    this.dragStartY = event.clientY - this.translateY;
  }
  onDrag(event: MouseEvent) {
    if (!this.dragging) return;
    this.translateX = event.clientX - this.dragStartX;
    this.translateY = event.clientY - this.dragStartY;
    this.clampPan();
  }
  endDrag() { this.dragging = false; }
  zoomOut() {
    const prev = this.zoom;
    this.zoom = this.clampZoom(+(this.zoom - this.zoomStep).toFixed(2) as any);
    this.translateX = 0 - (0 - this.translateX) * (this.zoom / prev);
    this.translateY = 0 - (0 - this.translateY) * (this.zoom / prev);
    this.clampPan();
  }
  zoomIn() {
    const prev = this.zoom;
    this.zoom = this.clampZoom(+(this.zoom + this.zoomStep).toFixed(2) as any);
    this.translateX = 0 - (0 - this.translateX) * (this.zoom / prev);
    this.translateY = 0 - (0 - this.translateY) * (this.zoom / prev);
    this.clampPan();
  }
  resetAdjust() {
    this.zoom = this.minZoomToFill();
    this.translateX = 0; this.translateY = 0;
  }

  onWheel(event: WheelEvent) {
    event.preventDefault();
    if (!this.uploadedImageSrc) return;
    const delta = Math.sign(event.deltaY);
    const factor = delta > 0 ? (1 - this.zoomStep) : (1 + this.zoomStep);
    const prev = this.zoom;
    const next = this.clampZoom(prev * factor);
    const target = event.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const pvx = event.clientX - cx;
    const pvy = event.clientY - cy;
    this.translateX = pvx - (pvx - this.translateX) * (next / prev);
    this.translateY = pvy - (pvy - this.translateY) * (next / prev);
    this.zoom = next;
    this.clampPan();
  }

  private prepareImageForAdjust(src: string) {
    const img = new Image();
    img.onload = () => {
      this.imgNatW = img.naturalWidth || img.width;
      this.imgNatH = img.naturalHeight || img.height;
      this.zoom = this.minZoomToFill();
      this.translateX = 0; this.translateY = 0;
      this.clampPan();
    };
    img.src = src;
  }

  private async processIncomingFile(file: File) {
    this.validationErrors = [];
    this.validationWarnings = [];

    // Single image only — ignore additional selections via UI by design

    // Type validation
    if (!file.type || !file.type.startsWith('image/')) {
      this.validationErrors.push('Only image files are allowed.');
    } else if (!this.allowedMime.has(file.type.toLowerCase())) {
      this.validationErrors.push('Allowed types: JPG, JPEG, PNG, WebP.');
    }

    // Size validation
    if (file.size > this.maxBytes) {
      this.validationErrors.push('File too large. Max size is 5 MB.');
    }

    // Early exit if hard validation fails before reading
    if (this.validationErrors.length) return;

    // Resolution + corruption check via Image
    const dataUrl = await new Promise<string>((resolve, reject) => {
      const r = new FileReader();
      r.onload = () => resolve(r.result as string);
      r.onerror = () => reject(new Error('Unreadable file.'));
      r.readAsDataURL(file);
    }).catch((e) => {
      this.validationErrors.push('Unreadable file. Please choose a valid image.');
      return '';
    });
    if (!dataUrl) return;

    const dimsOk = await new Promise<{ ok: boolean; w?: number; h?: number }>((resolve) => {
      const im = new Image();
      im.onload = () => resolve({ ok: true, w: im.naturalWidth, h: im.naturalHeight });
      im.onerror = () => resolve({ ok: false });
      im.src = dataUrl;
    });

    if (!dimsOk.ok) {
      this.validationErrors.push('Corrupted or unreadable image.');
      return;
    }

    const w = dimsOk.w || 0;
    const h = dimsOk.h || 0;
    // removed resolution check as told
    // if (w < 200 || h < 200) {
    //   this.validationErrors.push('Minimum resolution is 200×200 pixels.');
    // } else if (w < 500 || h < 500) {
    //   this.validationWarnings.push('Recommended resolution is 500×500 or higher.');
    // }

    // Aspect ratio (non-blocking guidance)
    // if (Math.abs(w - h) > 2) {
    //   this.validationWarnings.push('Square images (1:1) display best.');
    // }

    if (this.validationErrors.length) return;

    // Show Adjust only after validations pass
    this.uploadedImageSrc = dataUrl;
    this.showUploadPopup = false;
    this.showAdjustPopup = true;
    this.prepareImageForAdjust(this.uploadedImageSrc);
  }

  minZoomToFill(): number {
    // Reinterpret to support "contain inside circle":
    // minimum zoom that fits the entire image inside the circular ring (no cropping)
    if (!this.imgNatW || !this.imgNatH) return 1;
    const ring = document.querySelector('.pp-circle-ring') as HTMLElement | null;
    const d = Math.round(ring?.getBoundingClientRect().width || this.visibleDiameterFallback);
    const diag = Math.hypot(this.imgNatW, this.imgNatH);
    const minZ = d / (diag || 1);
    return Math.max(this.zoomMin, minZ);
  }
  private clampZoom(z: number): number {
    let v = typeof z === 'number' ? z : parseFloat(String(z));
    if (!isFinite(v) || v <= 0) v = 1;
    const minZ = this.minZoomToFill();
    return Math.min(this.zoomMax, Math.max(minZ, v));
  }
  private clampPan() {
    if (!this.imgNatW || !this.imgNatH) return;
    const ring = document.querySelector('.pp-circle-ring') as HTMLElement | null;
    const d = Math.round(ring?.getBoundingClientRect().width || this.visibleDiameterFallback);
    const r = d / 2;
    const halfW = (this.imgNatW * this.zoom) / 2;
    const halfH = (this.imgNatH * this.zoom) / 2;
    const maxX = Math.max(0, halfW - r);
    const maxY = Math.max(0, halfH - r);
    this.translateX = Math.max(-maxX, Math.min(maxX, this.translateX));
    this.translateY = Math.max(-maxY, Math.min(maxY, this.translateY));
  }

  // Highest-fidelity: replicate the preview in canvas, then cut the center circle
  // async savePhotoFinal() {
  //   if (!this.uploadedImageSrc) return;
  //   const img = new Image();
  //   img.onload = async () => {
  //     // 1) Draw the preview exactly as shown
  //     const vp = this.viewportSize;
  //     const ring = document.querySelector('.pp-circle-ring') as HTMLElement | null;
  //     const D = Math.round(ring?.getBoundingClientRect().width || this.visibleDiameterFallback);
  //     const off = document.createElement('canvas');
  //     off.width = vp; off.height = vp;
  //     const ctx = off.getContext('2d')!;
  //     ctx.clearRect(0, 0, vp, vp);
  //     ctx.imageSmoothingEnabled = true; // @ts-ignore
  //     ctx.imageSmoothingQuality = 'high';

  //     const iw = img.naturalWidth || img.width;
  //     const ih = img.naturalHeight || img.height;

  //     // Place origin at cropper center, then apply pan and zoom, and draw image centered at origin
  //     ctx.translate(vp / 2, vp / 2);
  //     ctx.translate(this.translateX, this.translateY);
  //     ctx.scale(this.zoom, this.zoom);
  //     ctx.drawImage(img, -iw / 2, -ih / 2, iw, ih);

  //     // 2) Extract the centered circular region matching the ring
  //     const out = document.createElement('canvas');
  //     out.width = D; out.height = D;
  //     const outCtx = out.getContext('2d')!;
  //     outCtx.imageSmoothingEnabled = true; // @ts-ignore
  //     outCtx.imageSmoothingQuality = 'high';
  //     outCtx.save();
  //     outCtx.beginPath();
  //     outCtx.arc(D / 2, D / 2, D / 2, 0, Math.PI * 2);
  //     outCtx.clip();
  //     const offset = Math.max(0, (vp - D) / 2);
  //     outCtx.drawImage(off, offset, offset, D, D, 0, 0, D, D);
  //     outCtx.restore();

  //     const dataUrl = out.toDataURL('image/png');
  //     this.currentPhotoSrc = dataUrl;

  //     try {
  //       this.fullLoaderService.showLoader('Uploading photo...');
  //       const s3path = await this.uploadCroppedPhotoToS3(dataUrl);
  //       this.currentPhotoS3Path = s3path;
  //       const userId = Number(this.cookieService.get('userId'));
  //       if (userId && s3path) {
  //         await this.settingsService.saveUserProfilePhotoUrl(userId, s3path);
  //         this.showAdjustPopup = false;
  //         this.showSuccessPopup = true;
  //       }
  //     } finally { this.fullLoaderService.hideLoader(); }
  //   };
  //   img.src = this.uploadedImageSrc;
  // }

  async savePhotoFinal() {
    if (!this.uploadedImageSrc) return;

    const imgEl = document.querySelector(
      '.pp-cropper-square img'
    ) as HTMLImageElement;

    const cropper = document.querySelector(
      '.pp-cropper-square'
    ) as HTMLElement;

    const ring = document.querySelector(
      '.pp-circle-ring'
    ) as HTMLElement;

    if (!imgEl || !cropper || !ring) return;

    const img = new Image();
    img.onload = async () => {
      const cropperRect = cropper.getBoundingClientRect();
      const ringRect = ring.getBoundingClientRect();
      const imgRect = imgEl.getBoundingClientRect();

      const ringSize = ringRect.width;

      //Calculated visible region

      // Ratio between original image and rendered image
      const scaleX = img.naturalWidth / imgRect.width;
      const scaleY = img.naturalHeight / imgRect.height;

      // Position of ring relative to image
      const srcX =
        (ringRect.left - imgRect.left) * scaleX;
      const srcY =
        (ringRect.top - imgRect.top) * scaleY;

      const srcSize = ringSize * scaleX;

      // Drawn circular crop

      const out = document.createElement('canvas');
      out.width = ringSize;
      out.height = ringSize;

      const ctx = out.getContext('2d')!;
      ctx.imageSmoothingEnabled = true;
      // @ts-ignore
      ctx.imageSmoothingQuality = 'high';

      ctx.save();
      ctx.beginPath();
      ctx.arc(
        ringSize / 2,
        ringSize / 2,
        ringSize / 2,
        0,
        Math.PI * 2
      );
      ctx.clip();

      // Ensure empty areas inside the ring are white (not transparent)
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, ringSize, ringSize);

      ctx.drawImage(
        img,
        srcX,
        srcY,
        srcSize,
        srcSize,
        0,
        0,
        ringSize,
        ringSize
      );

      ctx.restore();

      const dataUrl = out.toDataURL('image/png');
      this.currentPhotoSrc = dataUrl;

      try {
        this.fullLoaderService.showLoader('Uploading photo...');
        const s3path = await this.uploadCroppedPhotoToS3(dataUrl);

        const userId = Number(this.cookieService.get('userId'));
        if (userId && s3path) {
          await this.settingsService.saveUserProfilePhotoUrl(
            userId,
            s3path
          );
          // Persist profile path in cookie and local state for refresh safety
          try {
            await this.usersService.setCookie(
              'profilePath',
              s3path,
              1,
              '/',
              '',
              true,
              'Lax'
            );
          } catch {}
          this.currentPhotoSrc = s3path;
          this.currentPhotoS3Path = s3path;
          this.showAdjustPopup = false;
          this.showSuccessPopup = true;
        }
      } finally {
        this.fullLoaderService.hideLoader();
      }
    };

    img.src = this.uploadedImageSrc;
  }


  private async uploadCroppedPhotoToS3(dataUrl: string): Promise<string> {
    const blob: Blob = await (await fetch(dataUrl)).blob();
    const userAny: any = this.user || {};
    const uid = (userAny.userId || userAny.id || userAny.userid || 'user').toString();
    const key = `profile-photos/${uid}/${Date.now()}-${Math.random().toString(36).slice(2)}.png`;
    const s3Params = { fileKey: key, fileContentType: 'image/png' } as any;
    const signedUrl = await this.awsSdkService.getSignedUrlPromise(s3Params);
    await this.webApiService.putRequestExternalApi(signedUrl, blob);
    const s3path = this.awsSdkService.extractS3LocationFromUrl(signedUrl);
    return s3path;
  }

  // Position floating camera at avatar top-right, slight inset
  positionFloatingCamera = () => {
    clearTimeout(this.repositionCameraTimeout);
    this.repositionCameraTimeout = setTimeout(() => {
      const avatar = document.querySelector('.app-user-photo') as HTMLElement | null;
      const cam = document.querySelector('.camera-float') as HTMLElement | null;
      if (!avatar || !cam) return;
      const rect = avatar.getBoundingClientRect();
      const camW = cam.offsetWidth || 24;
      const inset = 6;
      // const x = rect.right - camW - inset;
      // const y = rect.top + inset;
      const x = rect.right - camW;
      const y = rect.top;
      cam.style.left = `${x}px`;
      cam.style.top = `${y}px`;
    }, 0);
  }

  logOut() {
    try {
      this.fullLoaderService.showLoader();
      localStorage.clear();
      console.log(localStorage.getItem('guestSessionId'),'local'); // Should print the value or null
      localStorage.removeItem('guestSessionId');
      
      let userId = JSON.parse(this.cookieService.get("tokenId"));

      if (userId !== null && userId !== "" && typeof userId !== "undefined") {
        this.usersService.logoutCurrentUser(userId).subscribe(
          (_userDetail:any) => {
            localStorage.clear();
            console.log(localStorage.getItem('guestSessionId'),'local'); // Should print the value or null
            localStorage.removeItem('guestSessionId');
            this.cookieService.deleteAll("/");
            this.fullLoaderService.hideLoader();
            setTimeout(() => {
              this.router.navigate(['/auth/signin']);
            }, 0);
          },
          (_httpErrorResponse: HttpErrorResponse) => {
            this.cookieService.deleteAll("/");
            this.fullLoaderService.hideLoader();
            setTimeout(() => {
              this.router.navigate(['/auth/signin']);
            }, 0);
          }
        );
      } else {
        this.fullLoaderService.hideLoader();
        this.cookieService.deleteAll("/");

        setTimeout(() => {
          this.router.navigate(['/auth/signin']);
        }, 0);
      }
    } catch (err) {
      this.fullLoaderService.hideLoader();
      this.cookieService.deleteAll("/");

      setTimeout(() => {
        this.router.navigate(['/auth/signin']);
      }, 0);
    }
  }
}
